export default "__VITE_ASSET__AvxFsHA$__"